import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Button, Table, Accordion } from "react-bootstrap";
import axios from "axios";
import Receipt from "../Receipt.jsx";
import TableReceipt from "../TableReceipt.jsx";
// import TableReceiptMini from "../TableReceiptMini.jsx";
import SummaryCard from "./SummaryCard.jsx";
import classes from "./AllSalesAnalysis.module.css";
import YesAndNoModal from "../Modals/YesAndNoModal.jsx";
import ReactExport from "react-export-excel-fixed-xlsx";
import PermissionContext from "../../../Store/permission-context";
import ReceiptSalesRecordsModal from "../Modals/ReceiptSalesRecordsModal.jsx";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const AllSalesAnalysis = (props) => {
  const [AxiosError, setAxiosError] = useState("");
  const [RetrievedSalesRecords, setRetrievedSalesRecords] = useState([]);
  const [ThisReceipt, setThisReceipt] = useState([]);
  const [Title, setTitle] = useState("");
  const [ShowReceipt, setShowReceipt] = useState(false);
  const [Rct, setRct] = useState({});
  const [CardTotalSales, setCardTotalSales] = useState(0);
  const [CardCash, setCardCash] = useState(0);
  const [CardPOS, setCardPOS] = useState(0);
  const [CardTransfer, setCardTransfer] = useState(0);
  const [CardCredit, setCardCredit] = useState(0);
  const [CardProfit, setCardProfit] = useState(0);
  const [CardTotalSalesWithoutDebt, setCardTotalSalesWithoutDebt] = useState(0);
  const [DisplayData, setDisplayData] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [IsPrinting, setIsPrinting] = useState(false);
  const [DisplaySummary, setDisplaySummary] = useState(false);
  const [showreceiptdetails, setshowreceiptdetails] = useState(false);
  const [Message, setMessage] = useState("");
  const [ModalType, setModalType] = useState("");
  const [ReceiptToDelete, setReceiptToDelete] = useState({});
  const PCtx = useContext(PermissionContext);

  useEffect(() => {
    console.log(props);
    let Records = props.Records;
    // console.log(Records);
    let TotalSales = 0;
    let TotalCash = 0;
    let TotalPOS = 0;
    let TotalCredit = 0;
    let TotalTransfer = 0;
    let TotalProfit = 0;
    let TotalSalesWithoutDebtPayment = 0;

    const getCardTotal = (AllSales) => {
      if (AllSales) {
        let ArrayLength = AllSales.length;
        for (var n = 0; n < ArrayLength - 1; n++) {
          TotalSalesWithoutDebtPayment += AllSales[n].RID.startsWith("D")
            ? 0
            : parseFloat(AllSales[n].Paid);
          TotalSales += parseFloat(AllSales[n].Paid);
          TotalCash += parseFloat(AllSales[n].Cash);

          TotalPOS += parseFloat(AllSales[n].POS);

          TotalTransfer += parseFloat(AllSales[n].Transfer);

          TotalCredit += parseFloat(AllSales[n].Credit);
          TotalProfit += parseFloat(AllSales[n].Profit);
        }
      }
    };

    if (props.myDates.type === "specific") {
      let ALLSALES =
        Records.ThisSalesRecords !== null ? Records.ThisSalesRecords : [];

      getCardTotal(ALLSALES);
    } else {
      let ALLSALES = Records;
      for (var m = 0; m < ALLSALES.length; m++) {
        getCardTotal(ALLSALES[m]["ThisSalesRecords"]);
      }
    }

    setCardTotalSales(TotalSales);
    setCardCash(TotalCash);
    PCtx.UpdReceivedCash(TotalCash);
    setCardPOS(TotalPOS);
    PCtx.UpdReceivedPOS(TotalPOS);
    setCardTransfer(TotalTransfer);
    PCtx.UpdReceivedTransfer(TotalTransfer);
    setCardCredit(TotalCredit);
    PCtx.UpdReceivedCredit(TotalCredit);
    setCardProfit(TotalProfit);
    setCardTotalSalesWithoutDebt(TotalSalesWithoutDebtPayment);
    setRetrievedSalesRecords(Records);
    setDisplayData(true);

    if (props.myDates.type === "specific") {
      setTitle((" for " + props.myDates.dates).toUpperCase());
    } else {
      let thedates = [...props.myDates.dates];
      setTitle(
        (
          "from " +
          thedates[0] +
          " to " +
          thedates[thedates.length - 1] +
          "."
        ).toUpperCase()
      );
    }
  }, []);

  useEffect(() => {
    if (Object.keys(ThisReceipt).length > 0) {
      setshowreceiptdetails(true);
    }
  }, [ThisReceipt]);

  const getThisReceipt = async (e, recs) => {
    e.preventDefault();
    const rdet = { rid: recs.RID, rdate: recs.DatePaid };
    const RDetails = await PCtx.connectAxios("getreceiptdetails.php", rdet);
    const Receipt = {
      OrderData: RDetails,
      Discount: recs.Discount,
      Payable: recs.Payable,
      PayableWithDiscount: parseFloat(recs.Paid),
      PaymentMode: recs.PaymentMode,
      cn: recs.Customer,
      pn: recs.Phone,
      ShowReceipt: true,
      rcn: recs.RID,
      rdt: recs.DatePaid,
    };
    let RInfo = {
      RID: recs.RID,
      RPayable: recs.Payable,
      RMode: recs.PaymentMode,
      RCust: recs.Customer,
      RPft: recs.Profit,
      cash: recs.Cash,
      pos: recs.POS,
      transfer: recs.Transfer,
      Tender: recs.Tender,
      ChangeCollected: recs.ChangeCollected,
    };
    let RD = { RDetails: RDetails, RInfo: RInfo };

    setThisReceipt(RD);

    if (RDetails.length > 0) {
      // console.log(Receipt);
      setRct(Receipt);
      setShowReceipt(true);
    }
  };

  const callToDeleteReceipt = (Rid, Rdt, ind, Amt) => {
    setReceiptToDelete({ Rid: Rid, Rdt: Rdt, ind: ind, Amt: Amt });
    setMessage(
      "Are you sure you want to delete a receipt that worth ₦" + Amt + "?"
    );
    setModalType("Error");
    setShowModal(true);
  };

  const PrintTheReport = () => {
    setIsPrinting(true);
    window.print();
    setIsPrinting(false);
  };

  const DeleteReceipt = () => {
    let RTD = { ...ReceiptToDelete, Username: PCtx.Username };
    props.DeleteFunction(RTD);
  };

  const NextEvent = () => {
    setShowModal(false);
    PCtx.setReloadReport(!PCtx.ReloadReport);
  };
  const NextEvent2 = (reload) => {
    setshowreceiptdetails(false);
    if (reload) {
      PCtx.setReloadReport(!PCtx.ReloadReport);
    }
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      ArrData.ThisSalesRecords != undefined &&
      ArrData.ThisSalesRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }

    return (
      <Row className="justify-content-around mt-3" key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header>
              {props.TheCustomer === "All" || props.TheCustomer == ""
                ? ""
                : props.TheCustomer.toUpperCase() + " "}
              SALES REPORT OF {ArrData.ThisDate.toUpperCase()}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent && (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>ReceiptID</th>
                      <th>Date_of_Transaction</th>
                      <th>Amount</th>
                      <th>Disc.</th>
                      <th>Paid</th>
                      <th>Cash</th>
                      <th>POS</th>
                      <th>Transfer</th>
                      <th>Credit</th>
                      <th>Tender</th>
                      <th>Balance</th>
                      <th>Staff</th>
                      <th>Customer</th>
                      <th>Phone</th>
                      {props.myDates.Category === "Group" && <th>Profit</th>}
                      {props.myDates.Category === "Group" && <th>Del</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {ArrData.ThisSalesRecords.map((rec, index) => (
                      <tr key={index}>
                        <td>
                          {index < ArrData.ThisSalesRecords.length - 1
                            ? index + 1
                            : ""}
                        </td>
                        <td>
                          {index < ArrData.ThisSalesRecords.length - 1 &&
                          rec.RID.charAt(0) != "D" ? (
                            <a href="#" onClick={(e) => getThisReceipt(e, rec)}>
                              {rec.RID}
                            </a>
                          ) : (
                            rec.RID
                          )}
                        </td>
                        <td>{rec.DatePaid}</td>
                        <td>
                          {index === ArrData.ThisSalesRecords.length - 1
                            ? DisplaySummary
                              ? rec.Payable
                              : "*****"
                            : rec.Payable}
                        </td>
                        <td>{rec.Discount}</td>
                        <td>
                          {index === ArrData.ThisSalesRecords.length - 1
                            ? DisplaySummary
                              ? rec.Paid
                              : "*****"
                            : rec.Paid}
                        </td>
                        <td>{rec.Cash}</td>
                        <td>{rec.POS}</td>
                        <td>{rec.Transfer}</td>
                        <td>{rec.Credit}</td>
                        <td>{rec.Tender}</td>
                        <td>{rec.ChangeCollected}</td>
                        <td>{rec.Staff}</td>
                        <td>{rec.Customer}</td>
                        <td>{rec.Phone}</td>
                        {props.myDates.Category === "Group" && (
                          <td>
                            {index === ArrData.ThisSalesRecords.length - 1
                              ? DisplaySummary
                                ? rec.Profit
                                : "*****"
                              : rec.Profit}
                          </td>
                        )}

                        {props.myDates.Category === "Group" && (
                          <td>
                            {index != ArrData.ThisSalesRecords.length - 1 &&
                              rec.RID.charAt(0) != "D" && (
                                <Button
                                  variant="outline-danger"
                                  onClick={() =>
                                    callToDeleteReceipt(
                                      rec.RID,
                                      ArrData.ThisDate,
                                      ind,
                                      rec.Paid
                                    )
                                  }
                                  className="btn-sm"
                                >
                                  -
                                </Button>
                              )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const ExportToExcel = (ArrData, indx) => {
    return (
      <ExcelSheet
        data={ArrData.ThisSalesRecords}
        name={ArrData.ThisDate}
        key={indx}
      >
        <ExcelColumn label="Receipt No" value="RID" />
        <ExcelColumn label="DATE_OF_TRANSACTION" value="DatePaid" />
        <ExcelColumn label="AMOUNT" value="Payable" />
        <ExcelColumn label="DISCOUNT" value="Discount" />
        <ExcelColumn label="PAID" value="Paid" />
        <ExcelColumn label="CASH" value="Cash" />
        <ExcelColumn label="POS" value="POS" />
        <ExcelColumn label="TRANSFER" value="Transfer" />
        <ExcelColumn label="CREDIT" value="Credit" />
        <ExcelColumn label="TENDER" value="Tender" />
        <ExcelColumn label="BALANCE" value="ChangeCollected" />
        <ExcelColumn label="CUSTOMER" value="Customer" />
        <ExcelColumn label="PHONE" value="Phone" />
        <ExcelColumn label="PROFIT" value="Profit" />
      </ExcelSheet>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisSalesRecords != undefined &&
      ArrData.ThisSalesRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase()}
        {props.TheCustomer === "All" || props.TheCustomer == ""
          ? ""
          : props.TheCustomer.toUpperCase() + " "}
        SALES REPORTS FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent && (
          <Table
            striped
            bordered
            responsive
            key={indx}
            className={classes.table4printing}
          >
            <thead>
              <tr>
                <th>SN</th>
                <th>ReceiptID</th>
                <th>Date_of_Transaction</th>
                <th>Amount</th>
                <th>Disc.</th>
                <th>Paid</th>
                <th>Cash</th>
                <th>POS</th>
                <th>Transfer</th>
                <th>Credit</th>
                <th>Tender</th>
                <th>Balance</th>
                <th>Staff</th>
                <th>Customer</th>
                <th>Phone</th>
                {props.myDates.Category === "Group" && <th>Profit</th>}
                <th>Del</th>
              </tr>
            </thead>
            <tbody>
              {ArrData.ThisSalesRecords.map((rec, index) => (
                <tr key={index}>
                  <td>
                    {index < ArrData.ThisSalesRecords.length - 1
                      ? index + 1
                      : ""}
                  </td>
                  <td>
                    {index < ArrData.ThisSalesRecords.length - 1 ? (
                      <a href="#" onClick={(e) => getThisReceipt(e, rec)}>
                        {rec.RID}
                      </a>
                    ) : (
                      rec.RID
                    )}
                  </td>
                  <td>{rec.DatePaid}</td>
                  <td>{rec.Payable}</td>
                  <td>{rec.Discount}</td>
                  <td>{rec.Paid}</td>
                  <td>{rec.Cash}</td>
                  <td>{rec.POS}</td>
                  <td>{rec.Transfer}</td>
                  <td>{rec.Credit}</td>
                  <td>{rec.Tender}</td>
                  <td>{rec.ChangeCollected}</td>
                  <td>{rec.Staff}</td>
                  <td>{rec.Customer}</td>
                  <td>{rec.Phone}</td>
                  {props.myDates.Category === "Group" && <td>{rec.Profit}</td>}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  const CloseThisReceipt = () => {
    setShowReceipt(false);
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Row className={classes.margin4printing}>
          {DisplayData && (
            <Row
              className={`${
                classes.margin4printing
              } ${"justify-content-around"}`}
            >
              <Col md={12} className={classes.hide4printing}>
                <p
                  style={{
                    fontFamily: "Times New Roman",
                    fontSize: "20px",
                    color: "brown",
                    textAlign: "center",
                  }}
                >
                  {props.myDates.Category === "Individual" &&
                    props.myDates.Staff.toUpperCase()}
                  {props.TheCustomer === "All" || props.TheCustomer == ""
                    ? ""
                    : props.TheCustomer.toUpperCase() + " "}
                  SALES REPORTS {Title}
                </p>
              </Col>

              <Col
                md={2}
                className={`${classes.hide4printing} ${classes.CardCol}`}
              >
                <Row className="justify-content-around mt-3">
                  <Col md={10} className={classes.CardCol}>
                    <Card>
                      <Card.Header className={classes.TheHeader}>
                        SUMMARY OF THE SELECTED DATE(S)
                      </Card.Header>
                      <Card.Body className="pt-0">
                        <Button
                          variant="info"
                          className="btn w-100 mt-2 mb-2 rounded-0"
                          onClick={() =>
                            setDisplaySummary(
                              (prevDisplaySummary) => !prevDisplaySummary
                            )
                          }
                        >
                          {DisplaySummary ? "Hide Summary" : "Display Summary"}
                        </Button>
                        <SummaryCard
                          Title="Total Sales "
                          Value={CardTotalSalesWithoutDebt + CardCredit}
                          dispSum={DisplaySummary}
                        />
                        <SummaryCard
                          Title="Total Received "
                          Value={CardTotalSales}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Payment by Cash "
                          Value={CardCash}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Payment by POS "
                          Value={CardPOS}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Payment by Transfer "
                          Value={CardTransfer}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="On Credit "
                          Value={CardCredit}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        {props.myDates.Category === "Group" && (
                          <SummaryCard
                            Title="Total Profit "
                            Value={CardProfit}
                            dispSum={DisplaySummary}
                          />
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col
                md={ShowReceipt ? 6 : 10}
                sm={12}
                xs={12}
                className={classes.margin4printing}
              >
                <Row
                  className={`${
                    classes.margin4printing
                  } ${"justify-content-around"}`}
                >
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.hide4printing}
                  >
                    <Accordion
                      defaultActiveKey={
                        props.TableToShow > -1 ? props.TableToShow : null
                      }
                    >
                      {props.myDates.type === "specific"
                        ? getTableCode(RetrievedSalesRecords, 0)
                        : RetrievedSalesRecords.map((rtrvrec, index) =>
                            getTableCode(rtrvrec, index)
                          )}
                    </Accordion>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.margin4printing}
                  >
                    {IsPrinting
                      ? props.myDates.type === "specific"
                        ? TableForPrinting(RetrievedSalesRecords, 0)
                        : RetrievedSalesRecords.map((rtrvrec, index) =>
                            TableForPrinting(rtrvrec, index)
                          )
                      : null}
                    {IsPrinting && (
                      <Row>
                        <Col md={2}>
                          <SummaryCard
                            Title="Total Sales "
                            Value={CardTotalSales}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Payment by Cash "
                            Value={CardCash}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Payment by POS "
                            Value={CardPOS}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Payment by Transfer "
                            Value={CardTransfer}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Payment by Transfer "
                            Value={CardTransfer}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Payment by Credit "
                            Value={CardCredit}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard Title="Profit " Value={CardProfit} />
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <Button variant="info" onClick={PrintTheReport}>
                      Print
                    </Button>
                  </Col>
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <ExcelFile
                      element={
                        <Button variant="info" className="my-2">
                          EXPORT TO EXCEL
                        </Button>
                      }
                      filename={
                        (props.myDates.Category === "Individual"
                          ? props.myDates.Staff.toUpperCase()
                          : "") +
                        " SALES REPORT FOR " +
                        (props.myDates.type === "specific"
                          ? RetrievedSalesRecords.ThisDate
                          : RetrievedSalesRecords[0].ThisDate +
                            "-" +
                            RetrievedSalesRecords[
                              RetrievedSalesRecords.length - 1
                            ].ThisDate
                        ).toUpperCase()
                      }
                    >
                      {props.myDates.type === "specific"
                        ? ExportToExcel(RetrievedSalesRecords, 0)
                        : RetrievedSalesRecords.map((rtvdata, ind) =>
                            ExportToExcel(rtvdata, ind)
                          )}
                    </ExcelFile>
                  </Col>
                </Row>
              </Col>

              {ShowReceipt && (
                <Col md={4} sm={12} xs={12} className={classes.margin4printing}>
                  <TableReceipt Rct={Rct} PrintDirectly={false} />
                  <Button
                    variant="info"
                    className="w-100 mt-2"
                    onClick={CloseThisReceipt}
                  >
                    Close this Receipt
                  </Button>
                </Col>
              )}
            </Row>
          )}
        </Row>
      </Col>

      {ShowModal && (
        <YesAndNoModal
          showmodal={ShowModal}
          message={Message}
          modaltype={ModalType}
          deletereceipt={DeleteReceipt}
          NextEvent={NextEvent}
        />
      )}
      {showreceiptdetails && (
        <ReceiptSalesRecordsModal
          showmodal={showreceiptdetails}
          modaltype={ModalType}
          paymentReceipt={ThisReceipt}
          NextEvent={NextEvent2}
          Group={props.myDates.Category}
        />
      )}
    </Row>
  );
};

export default AllSalesAnalysis;
